import {
  useGetCloneMetricsQuery,
  useGetRecordingQuery,
} from '@carboncopyco/data';
import { InfoIcon } from '@carboncopyco/icons';
import { RecordingTypes } from '@carboncopyco/types';
import { ColorHex, InlineLink, TextCaption } from '@carboncopyco/ui';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ContinueCloningKBLink } from '../../../ContinueCloning';
import { useClonePageProps } from '../ClonePageContext';
import { ClonePageTabLayout } from '../ClonePageTabLayout';
import { CloneOverviewCard, hasMetricsData } from './CloneOverviewCard';
import { DemosCard } from './DemosCard';
import { DetailsCard } from './DetailsCard';
import { ScreensCard } from './ScreensCard';

export const OverviewTab = () => {
  const {
    continueCloningProps: { timeLeftToEditClone },
    organizationId,
    cloneId,
    workspaceId,
  } = useClonePageProps();
  const { data: clone } = useGetRecordingQuery(
    {
      organizationId,
      id: Number(cloneId),
    },
    { skip: !cloneId || !organizationId }
  );
  const flags = useFlags();

  const { data: metrics, error } = useGetCloneMetricsQuery({
    organizationId: organizationId,
    recordingId: cloneId as string,
    workspacesIds: [workspaceId],
  });

  return (
    <ClonePageTabLayout>
      <div className="w-full">
        {timeLeftToEditClone && (
          <div className="flex items-center rounded gap-1.5 pl-2.5 py-0.5 mb-4 bg-ds-natural-100 text-ds-natural-150 border border-ds-natural-150 w-full">
            <div>
              <InfoIcon
                size={16}
                color={ColorHex.natural500}
              />
            </div>
            <TextCaption
              label={`You can continue cloning for the next ${timeLeftToEditClone}. Find this action under the "Actions" button.`}
              color="text-ds-natural-600"
            />
            <InlineLink
              label="Learn more"
              target="_blank"
              fontSize="text-ds-200"
              href={ContinueCloningKBLink}
              className="inline-flex leading-ds-200 font-ds-light text-ds-natural-600"
            />
          </div>
        )}
        <div className="flex gap-6">
          <div className="flex-1">
            <DetailsCard />
          </div>
          {flags.cloneExperienceWidget &&
            (hasMetricsData(metrics) || error) && (
              <div className="flex-1">
                <CloneOverviewCard />
              </div>
            )}
        </div>
        <div className="mt-6">
          <DemosCard />
        </div>
        {clone?.recordingType !== RecordingTypes.mobile && (
          <div className="mt-6">
            <ScreensCard />
          </div>
        )}
      </div>
    </ClonePageTabLayout>
  );
};
